import PriceSelector from '@/components/config-editor/form-elements/PriceSelector';
import { WidgetProps } from '@rjsf/utils';

function PriceSelectorWidget(props: WidgetProps) {
  return <PriceSelector value={props.value} onChange={props.onChange} />;
}

export default PriceSelectorWidget;
